// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"aff7c938","365":"6dd280f7","453":"6c4140d0","455":"58aff909","569":"60834cb9","642":"3b97cc0d","757":"d916d01c","876":"9fd0847c","888":"8b493c31"}[chunkId] + ".chunk.js";
};